import { useEffect, useState } from "react";
import "../Styles/AgentDetails.css";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../assests/images/default_busi_logo.png";
import { IoChevronBackOutline } from "react-icons/io5";

import { get_agent_reviews } from "../api/serverWrapper";
import LangIcon from "../assests/images/lang-icon.png";
import {
  FaMapMarkerAlt,
  FaClock,
  FaPhoneAlt,
  FaEnvelope,
  FaGlobe,
  FaCheckCircle,
  FaShareAlt,
  FaUser
} from "react-icons/fa";
import { getDefaultProfileIcon, RatingStars } from "../utils/commonFunctions";

function AgentDetails() {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    partner,
    religionOptions,
    casteOptions,
    communityOptions,
    languages,
    fromMyAgent,
  } = location.state || {};

  console.log(partner);

  const [agentReviews, setAgentReviews] = useState([]);

  useEffect(() => {
    loadAgentReviews();
  }, []);

  const [pricingModel, setPricingModel] = useState(
    partner.PricingModel || "One time payment",
  );
  const [pricingAmount, setPricingAmount] = useState(
    partner.PricingAmount || "$12 per 15 matches",
  );
  const [paymentMethods, setPaymentMethods] = useState(
    partner.PaymentMethods || [
      { value: "Bank transfer", label: "Bank transfer" },
      { value: "UPI", label: "UPI" },
    ],
  );

  const loadAgentReviews = async () => {
    try {
      const response = await get_agent_reviews(partner?.UserId);

      if (response?.code === 200) {
        setAgentReviews(response?.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // ---- Reviews summary (rating breakdown bars) ----
  const totalReviews = agentReviews?.length || 0;

  const ratingBreakdown = [5, 4, 3, 2, 1].map((star) => {
    const count =
      agentReviews?.filter((r) => Math.round(r?.Rating) === star).length || 0;
    const pct = totalReviews > 0 ? (count / totalReviews) * 100 : 0;
    return { star, count, pct };
  });

  const averageRating =
    partner?.AverageRating ??
    (totalReviews > 0
      ? (
          agentReviews.reduce((sum, r) => sum + (r?.Rating || 0), 0) /
          totalReviews
        ).toFixed(1)
      : 0);

  const galleryImages =
    partner?.PromotionalImages?.length > 0
      ? partner.PromotionalImages
      : [
          "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?q=80&w=1200&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1520854221256-17451cc331bf?q=80&w=1200&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=1200&auto=format&fit=crop",
        ];

  const visibleGalleryImages = galleryImages.slice(0, 4);
  const remainingGalleryCount =
    galleryImages.length - visibleGalleryImages.length;

  const formatReviewDate = (dateString) => {
    if (!dateString) return "";
    try {
      return new Date(dateString).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
    } catch {
      return "";
    }
  };

  const agentFullName = [partner?.User?.FirstName, partner?.User?.LastName]
    .filter(Boolean)
    .join(" ");

  return (
    <div className=" ">
      <div className="client-setup-header-main">
        <div className="client-setup-header-left">
          <IoChevronBackOutline
            className="client-setup-back-icon"
            onClick={() => navigate(-1)}
          />

          <img
            src={require("../assests/images/nav_bar_logo.png")}
            alt="Wedluk Logo"
            className="client-setup-logo"
          />
        </div>

        <div className="client-setup-header-right">
          <span> Registered partners </span>
        </div>
      </div>

      {/* MAIN CARD */}

      <div className="review-main-card mx-4 my-4">
        {/* BUSINESS HEADER: logo + business name + verified badge */}

        <div className="ag-business-header">
          <img
            src={partner?.BusinessLogo || Logo}
            alt=""
            className="ag-business-logo"
          />

          <div className="ag-business-header-text">
            <h1 className="ag-business-name">{partner?.BusinessName}</h1>

            {(partner?.IsVerified ?? true) && (
              <span className="ag-verified-badge">
                <FaCheckCircle /> Verified Agent
              </span>
            )}
          </div>
        </div>

        {/* AGENT PROFILE PHOTO + CONTACT DETAILS */}

        <div className="ag-profile-row">
          <img
            src={
              partner?.User?.ProfilePhotoUrl ||
              getDefaultProfileIcon(partner?.User)
            }
            alt=""
            className="ag-profile-photo"
          />

          <ul className="ag-contact-list">
            <li>
              <FaUser className="ag-contact-icon" />
              {agentFullName || "-"}
            </li>
            {(partner?.User?.Address?.CityId ||
              partner?.User?.Address?.CountryId) && (
              <li>
                <FaMapMarkerAlt className="ag-contact-icon" />
                {[
                  partner?.User?.Address?.CityId,
                  partner?.User?.Address?.CountryId,
                ]
                  .filter(Boolean)
                  .join(", ")}
              </li>
            )}

            <li>
              <FaPhoneAlt className="ag-contact-icon" />+
              {partner?.User?.CountryCode ?? 91}{" "}
              {partner?.User?.PhoneNumber ? partner?.User?.PhoneNumber : "-"}
            </li>

            <li>
              <FaEnvelope className="ag-contact-icon" />
              {partner?.User?.EMail ? partner?.User?.EMail : "-"}
            </li>

            {partner?.Website && (
              <li>
                <FaGlobe className="ag-contact-icon" />
                {partner?.Website}
              </li>
            )}

            <li>
              <FaClock className="ag-contact-icon" />
              {partner?.BusinessExperience || 0} years experience
            </li>

            <li className="ag-contact-languages">
              <img className="icons-for-partner me-2" src={LangIcon} alt="" />
              {partner?.LanguagesServe?.includes("all")
                ? "All Languages"
                : languages
                    ?.filter((item) =>
                      partner?.LanguagesServe?.includes(item.LangId),
                    )
                    ?.map((item) => item.LangDesc)
                    ?.join(", ")}
            </li>
          </ul>
        </div>

        {/* ABOUT */}

        {partner?.BusinessDescription && (
          <div className="ag-review-about-section">
            <h3>About</h3>

            <p>{partner?.BusinessDescription}</p>
          </div>
        )}

        {/* SERVICES OFFERED + PRICING */}

        <div className="ag-services-section">
          <div className="ag-services-left">
            <h3>Services Offered</h3>

            <div className="ag-service-line">
              <span className="ag-service-label">Religions</span>
              <span className="ag-service-value">
                {partner?.ReligionsServe?.includes("all")
                  ? "All Religions"
                  : religionOptions
                      ?.filter((o) =>
                        partner?.ReligionsServe?.includes(o.value),
                      )
                      ?.map((item) => item.label)
                      ?.join(", ")}
              </span>
            </div>

            <div className="ag-service-line">
              <span className="ag-service-label">Castes</span>
              <span className="ag-service-value">
                {partner?.CastesServe?.includes("all")
                  ? "All Castes"
                  : casteOptions
                      ?.filter((o) => partner?.CastesServe?.includes(o.value))
                      ?.map((item) => item.label)
                      ?.join(", ")}
              </span>
            </div>

            <div className="ag-service-line">
              <span className="ag-service-label">Communities</span>
              <span className="ag-service-value">
                {partner?.CommunitesServe?.includes("all")
                  ? "All Communities"
                  : communityOptions
                      ?.filter((o) =>
                        partner?.CommunitesServe?.includes(o.value),
                      )
                      ?.map((item) => item.label)
                      ?.join(", ")}
              </span>
            </div>

            <div className="ag-service-line">
              <span className="ag-service-label">Languages</span>
              <span className="ag-service-value">
                {partner?.LanguagesServe?.includes("all")
                  ? "All Languages"
                  : languages
                      ?.filter((o) =>
                        partner?.LanguagesServe?.includes(o.LangId),
                      )
                      ?.map((item) => item.LangDesc)
                      ?.join(", ")}
              </span>
            </div>
          </div>

          <div className="ag-services-right">
            <div className="ag-pricing-card">
              <div className="ag-pricing-card-top">
                <span className="ag-pricing-card-icon">💳</span>
                <span>{pricingModel || "One time payment"}</span>
              </div>

              <div className="ag-pricing-card-amount">
                {pricingAmount || "$12 per 15 matches"}
              </div>

              <div className="ag-pricing-card-methods">
                {paymentMethods?.length > 0
                  ? paymentMethods.map((item) => item.label || item).join(" • ")
                  : "No payment methods selected"}
              </div>
            </div>

            <p className="ag-review-note">
              *Those prices are set by the agent for their services independent
              of Wedluk. Wedluk does not collect or cancel these fees.
            </p>
          </div>
        </div>

        {/* MEDIA GALLERY */}

        <h3 className="ag-gallery-heading">Media Gallery</h3>

        <div className="ag-gallery-images">
          {visibleGalleryImages.map((img, index) => {
            const isLastVisible =
              index === visibleGalleryImages.length - 1 &&
              remainingGalleryCount > 0;

            return (
              <div className="ag-gallery-img-wrap" key={index}>
                <img src={img} alt="" />
                {isLastVisible && (
                  <div className="ag-gallery-more-overlay">
                    +{remainingGalleryCount} More
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* CLIENT REVIEWS */}

        <div className="client-review-main">
          <div className="client-review-header">
            <h3 className="ag-gallery-heading">Client reviews</h3>
          </div>

          <div className="ag-review-summary-layout">
            {/* Rating breakdown */}
            <div className="ag-review-summary-card">
              <div className="ag-review-summary-score">{averageRating}/5</div>

              <div className="ag-review-summary-stars">
                <RatingStars rating={partner?.AverageRating} />
              </div>

              <div className="ag-review-summary-bars">
                {ratingBreakdown.map((row) => (
                  <div className="ag-rating-bar-row" key={row.star}>
                    <span className="ag-rating-bar-label">{row.star} ★</span>

                    <div className="ag-rating-bar-track">
                      <div
                        className="ag-rating-bar-fill"
                        style={{ width: `${row.pct}%` }}
                      />
                    </div>

                    <span className="ag-rating-bar-count">{row.count}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Review cards */}
            <div className="ag-review-card-list">
              {agentReviews?.length > 0 ? (
                agentReviews.slice(0, 2).map((item, index) => (
                  <div className="ag-review-card" key={index}>
                    <div className="ag-review-card-top">
                      <img
                        src={
                          item?.Profile?.User?.ProfilePhotoUrl ||
                          getDefaultProfileIcon(item?.Profile?.User)
                        }
                        alt=""
                      />

                      <div className="ag-review-card-name-block">
                        <h4>{item?.Profile?.User?.FirstName}</h4>

                        <div className="ag-review-card-stars">
                          {"★".repeat(item?.Rating || 0)}
                          {"☆".repeat(5 - (item?.Rating || 0))}
                        </div>
                      </div>
                    </div>

                    <p className="ag-review-card-comment">
                      "{item?.ReviewComment}"
                    </p>

                    <span className="ag-review-card-date">
                      {formatReviewDate(item?.CreatedAt)}
                    </span>
                  </div>
                ))
              ) : (
                <div className="text-center py-4">No Reviews Found</div>
              )}
            </div>
          </div>
        </div>

        {/* FOOTER ACTIONS */}

        <div className="ag-footer-actions">
          {/* <button
            className="ag-footer-btn ag-footer-btn-outline"
            onClick={() => navigate(-1)}
          >
            ‹ Back to Browse Agents
          </button> */}

          <button
            className="ag-footer-btn ag-footer-btn-primary"
            onClick={() =>
              navigate("/all-agent-reviews", {
                state: { agentReviews, partner },
              })
            }
          >
            View All Reviews
          </button>

          <button className="ag-footer-btn ag-footer-btn-outline">
            <FaShareAlt /> Share Profile
          </button>

          <button className="ag-footer-btn ag-footer-btn-dark">
            Contact Agent
          </button>
        </div>
      </div>
    </div>
  );
}

export default AgentDetails;
